import { render, staticRenderFns } from "./ArtworkViewModal.vue?vue&type=template&id=19f21045&scoped=true"
import script from "./ArtworkViewModal.vue?vue&type=script&lang=js"
export * from "./ArtworkViewModal.vue?vue&type=script&lang=js"
import style0 from "./ArtworkViewModal.vue?vue&type=style&index=0&id=19f21045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f21045",
  null
  
)

export default component.exports